import { DateTime } from 'luxon'
import type { PackageSubscription } from '@/types/dashboard/hosting'

// Mirrors the backend's mailentitlement.PlanBilling, which decides whether a
// package may still gain sites: dunning and a cancellation inside its paid
// period still bill.
export function packageBilling(
  sub: Pick<PackageSubscription, 'status' | 'access_until'>,
  now: Date = new Date()
): boolean {
  switch (sub.status) {
    case 'active':
    case 'suspended':
      return true
    case 'canceled':
      return !!sub.access_until && new Date(sub.access_until).getTime() > now.getTime()
    default:
      return false
  }
}

// The last day a suspended site's data can be retrieved: the Berlin calendar
// day before deletion_at, formatted as the backend's lifecycle mails name it.
export function retrievalLastDay(deletionAt: string, locale: string): string {
  const day = DateTime.fromISO(deletionAt, { zone: 'Europe/Berlin' }).minus({ days: 1 })
  if (!day.isValid) return ''
  return locale === 'en'
    ? day.setLocale('en-GB').toFormat('d MMMM yyyy')
    : day.toFormat('dd.MM.yyyy')
}
